import { mapTargetBySelectors } from '@/features/shared/HOCs/withGTM';
import { OnDatalayerProps } from '@/features/shared/HOCs/withGTM.interface';
import { pushClickToDL, TabsDLClick } from '../ComplexTabsList.datalayer';

enum Selectors {
  // Target
  CTA = 'a',
  Tab = '.gtm-tab',
  // Content
  TabHeadline = '.gtm-headline',
  CTAheadline = '.gtm-tab[aria-selected="true"] .gtm-headline',
}

export const mapTarget = mapTargetBySelectors([Selectors.CTA, Selectors.Tab]);

export const onDatalayer = ({ componentRef, target }: OnDatalayerProps) => {
  if (!target) {
    return undefined;
  }

  const variantName = (target?.closest('[data-datalayer-variant]') as HTMLDivElement)?.dataset
    ?.datalayerVariant;
  const isTab = target?.classList.contains(Selectors.Tab.replace('.', ''));

  if (isTab) {
    const documentHeadline = target?.querySelector(Selectors.TabHeadline)?.textContent || '';

    return {
      event: 'clickTab',
      eventCategory: 'Complex Tab',
      ...(!!documentHeadline && { documentHeadline }),
      ...(!!documentHeadline && { tabLabel: documentHeadline }),
      ...(variantName && { variant_name: variantName }),
    };
  }

  const documentHeadline =
    componentRef?.current?.querySelector(Selectors.CTAheadline)?.textContent || '';

  // Scroll
  return {
    event: 'clickCTA',
    eventCategory: 'Complex Tab',
    ...(!!documentHeadline && { documentHeadline }),
    ...(variantName && { variant_name: variantName }),
  };
};

export const onDatalayerTabClick = ({
  componentRef,
  target,
}: OnDatalayerProps): TabsDLClick | undefined => {
  if (!target) {
    return undefined;
  }

  const elWithTabIndex = target.closest('[role=tab]') || target.closest('[role=tabpanel]');
  const title = elWithTabIndex.querySelector('.gtm-headline').children[0].textContent;
  return pushClickToDL({ title, target });
};
